<div class="row">
    <div class="col-md-12 col-sm-12 table-responsive no-border">
        <form [formGroup]="deviceForm" novalidate>
            <table class="table table-condensed">
                <tbody>
                    <tr>
                        <td class="col-sm-3 no-left-padding">
                            <table class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>Reusable Surgical Instrument?</th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Reusable Surgical Instrument?')">
                                            <label controlName="reusableSurgical"></label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td class="col-sm-3">
                            <table class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>Measuring Function?</th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Measuring Function?')">
                                            <label controlName="measuringFunction"></label>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td class="col-sm-3">
                            <table class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>Active Device?</th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Active Device?')">
                                            <label controlName="activePowered"></label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td class="col-sm-3 no-right-padding">
                            <table class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>Administer or Remove a Medicinal Substance?</th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Administer or Remove a Medicinal Substance?')">
                                            <label controlName="administeringMedicine"></label>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="table table-condensed">
                <tbody>
                    <tr>
                        <td class="col-sm-3 no-left-padding">

                            <table class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>Implantable?</th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Implantable?')">
                                            <label controlName="implantable"></label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td class="col-sm-9 no-right-padding" *ngIf="!showRiskClassImplantable()">
                            <table class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>
                                            For Risk Class IIb implantable: Sutures, Staples, Dental Fillings,
                                            Dental Braces, Tooth Crowns, Screws, Wedges, Pins, Clips, and
                                            Connectors?
                                        </th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('For Risk Class IIb implantable?')">
                                            <label controlName="forRiskClassImplantable"></label>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="table table-condensed">
                <tbody>
                    <tr>
                        <td class="col-sm-4 no-left-padding">

                            <table class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>Presence of Human Tissues, Cells, or Derivatives?</th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Presence of Human Tissues, Cells, or Derivatives?')">
                                            <label controlName="containingHumanTissues"></label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>

                        <td class="col-sm-4">

                            <table class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>Presence of Animal Tissues, Cells, or Derivatives?</th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Presence of Animal Tissues, Cells, or Derivatives?')">
                                            <label controlName="containingAnimalTissues"></label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </td>

                        <td class="col-sm-4 no-right-padding">
                            <table class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>Presence of a Medicinal Product Substance?</th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Presence of a Medicinal Product Substance?')">
                                            <label controlName="containsMedicinalProductSubstance"></label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>

                    </tr>
                </tbody>
            </table>
            <table class="table table-condensed">
                <tbody>
                    <tr>
                        <td class="col-sm-4 no-left-padding no-right-padding">
                            <table class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th>
                                            Presence of a Medicinal Product Substance Derived from Human Blood or
                                            Plasma?
                                        </th>
                                    </tr>
                                    <tr>
                                        <td [ngClass]="isDefault('Presence of a Medicinal Product Substance Derived from Human Blood or Plasma?')">
                                            <label controlName="containsBloodOrPlasmaSubstance"></label>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>

                        </td>
                    </tr>

                </tbody>
            </table>

            <table class="table table-condensed">
                <tbody>
                    <tr *ngIf="!showLegacy">
                        <td class="col-sm-12 no-left-padding no-right-padding">

                            <table formArrayName="medPurposeForm" class="table table-inner table-condensed">
                                <tbody>
                                    <tr>
                                        <th class="col-sm-8 right-padding-20">Medical Purpose of System or Procedure Pack?</th>
                                        <th class="col-sm-4">Language</th>
                                    </tr>
                                    <tr formGroupName="{{i}}"
                                        *ngFor="let med of medPurposeForm.controls; let i = index">
                                        <td [ngClass]="isDefault('Medical Purpose of System or Procedure Pack?')">
                                            <label controlName="value"></label>
                                        </td>
                                        <td [ngClass]="isDefault('Medical Purpose of System or Procedure Pack?')">
                                            <label controlName="language"></label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="table table-condensed">
              <tbody>
                  <tr>
                      <td class="col-sm-5 no-left-padding">

                          <table class="table table-inner table-condensed">
                              <tbody>
                                  <tr>
                                      <th>Presence of Cells or Substances of Microbial Origin?</th>
                                  </tr>
                                  <tr>
                                      <td [ngClass]="isDefault('Presence of Cells or Substances of Microbial Origin?')">
                                          <label controlName="containsMicrobialSubstances"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>

                      <td class="col-sm-2">

                          <table class="table table-inner table-condensed">
                              <tbody>
                                  <tr>
                                      <th>Companion Diagnostic?</th>
                                  </tr>
                                  <tr>
                                      <td [ngClass]="isDefault('Companion Diagnostic?')">
                                          <label controlName="companionDiagnostic"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>

                      </td>

                      <td class="col-sm-3 no-right-padding">
                          <table class="table table-inner table-condensed">
                              <tbody>
                                  <tr>
                                      <th>Near Patient Testing?</th>
                                  </tr>
                                  <tr>
                                      <td [ngClass]="isDefault('Near Patient Testing?')">
                                          <label controlName="nearPatientTesting"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>
                      <td class="col-sm-2 no-right-padding">
                        <table class="table table-inner table-condensed">
                            <tbody>
                                <tr>
                                    <th>Patient Self Testing?</th>
                                </tr>
                                <tr>
                                    <td [ngClass]="isDefault('Patient Self Testing?')">
                                        <label controlName="patientSelfTesting"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                  </tr>
              </tbody>
          </table>
          <table class="table table-condensed">
            <tbody>
                <tr>
                    <td class="col-sm-3 no-left-padding">

                        <table class="table table-inner table-condensed">
                            <tbody>
                                <tr>
                                    <th>Reagent?</th>
                                </tr>
                                <tr>
                                    <td [ngClass]="isDefault('Reagent?')">
                                        <label controlName="reagent"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>

                    <td class="col-sm-3">

                        <table class="table table-inner table-condensed">
                            <tbody>
                                <tr>
                                    <th>Professional Testing?</th>
                                </tr>
                                <tr>
                                    <td [ngClass]="isDefault('Professional Testing?')">
                                        <label controlName="professionalTesting"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </td>

                    <td class="col-sm-3 no-right-padding">
                        <table class="table table-inner table-condensed">
                            <tbody>
                                <tr>
                                    <th>Instrument?</th>
                                </tr>
                                <tr>
                                    <td [ngClass]="isDefault('Instrument?')">
                                        <label controlName="instrument"></label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                    <td class="col-sm-3 no-right-padding">
                      <table class="table table-inner table-condensed">
                          <tbody>
                              <tr>
                                  <th>IVD Kit?</th>
                              </tr>
                              <tr>
                                  <td [ngClass]="isDefault('IVD Kit?')">
                                      <label controlName="ivdKit"></label>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </td>
                </tr>
            </tbody>
        </table>
        </form>
    </div>
</div>
